import { useEffect, useState } from "react";
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';
import * as referenceService from '../services/referenceService';
import Swal from "sweetalert2";
import { Link } from 'react-router-dom';
import { FormatDate } from "../../utils/RegisterApplicationBodyFormatter";

export const BookOfActionsReference = () => {
    const [loading, setLoading] = useState(false);
    const [actions, setActions] = useState([]);
    const [filter, setFilter] = useState({
        dateFrom: null,
        dateTo: new Date()
    })
    const [resetActions, setResetActions] = useState(false);

    useEffect(() => {
        setLoading(true)
        referenceService.getBookOfActions()
            .then((data) => {
                setActions(data);
                setLoading(false)
            })
            .catch((err) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: err.message,
                    icon: "warning",
                    button: "Добре",
                });
                setLoading(false);
            })
    }, [resetActions])

    const resetFilter = (e) => {
        e.preventDefault();

        setFilter({
            dateFrom: null,
            dateTo: new Date()
        })

        setResetActions(state => !state);
    }

    const onSearch = (e) => {
        e.preventDefault();
        setLoading(true)

        const fromDate = FormatDate(filter.dateFrom)
        const toDate = FormatDate(filter.dateTo)

        referenceService.getBookOfActions(fromDate, toDate)
            .then((data) => {
                setActions(data);
                setLoading(false)
            })
            .catch((err) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: err.message,
                    icon: "warning",
                    button: "Добре",
                });
                setLoading(false);
            })
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilter({ ...filter, [name]: value });
    };

    const actionIdBodyTemplate = (action) => {
        const dataForTag = getDataForTag(action)

        return <Tag value={dataForTag.text} severity={dataForTag.severity}></Tag>;
    };

    const header = (
        <div className="d-flex flex-wrap align-items-center justify-content-start gap-4 w-60 w-100-l">
            <Calendar
                showButtonBar
                locale='bg'
                className="prime-dropdown-heigth"
                name={`dateFrom`}
                value={filter.dateFrom}
                onChange={handleChange}
                showIcon
                maxDate={new Date()}
                placeholder='От дата'
            />
            <Calendar
                showButtonBar
                locale='bg'
                className="prime-dropdown-heigth"
                name={`dateTo`}
                value={filter.dateTo}
                onChange={handleChange}
                showIcon
                maxDate={new Date()}
                placeholder='До дата'
            />
            <Button className="btn btn-primary" label="Търси" icon="pi pi-search" disabled={!filter.dateFrom || !filter.dateTo} onClick={onSearch} />
            <Button className="btn btn-secondary" label="Изчисти филтър" icon="pi pi-undo" disabled={!filter.dateFrom}  onClick={resetFilter} />
        </div>
    );

    const getDataForTag = (action) => {
        switch (action.actionId) {
            case 0:
                return { text: 'Регистрация', severity: 'primary' };

            case 1:
            case 4:
                return { text: 'Приет/Записан', severity: 'success' };

            case 2:
            case 7:
            case 8:
            case 9:
            case 10:
            case 100:
            case 101:
            case 102:
                return { text: 'Анулиран/Отказан', severity: 'danger' };

            case 30:
                return { text: 'Редакция', severity: 'warning' };

            case 40:
            case 41:
                return { text: 'Свободни места', severity: 'info' }; 

            case 103:
                return { text: 'Създаване на потребител', severity: 'info' }; 
            case 104:
                return { text: 'Редакция на потребител', severity: 'info' }; 
            
            default:
                return { text: '', severity: 'info' };
        }
    };

    return (
        <main id="main" className="main">
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            <div className="pagetitle">
                <h1 className="use-font">Дневник на дейности</h1>

                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/schadm">Начало</Link></li>
                        <li className="breadcrumb-item active">Дневник на дейности</li>
                    </ol>

                </nav>

            </div>

            <section className="section dashboard">

                <div className="row">

                    <div className="col-lg-12">

                        <div className="row mt-2">
                            <DataTable value={actions} header={header} scrollable scrollHeight="74vh" stripedRows size='small' loading={loading}>
                                <Column field="action" header="Дейност"></Column>
                                <Column field="actionDate" header="Дата на дейността" ></Column>
                                <Column field="actionId"  header="Операция" body={actionIdBodyTemplate}></Column>
                            </DataTable>
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}